import { render, staticRenderFns } from "./DialogAskForAge.vue?vue&type=template&id=9b60e2f4&scoped=true&"
import script from "./DialogAskForAge.vue?vue&type=script&lang=js&"
export * from "./DialogAskForAge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b60e2f4",
  null
  
)

export default component.exports